import { motion } from "framer-motion";
import { Mail, MapPin } from "lucide-react";
import { fadeUp, stagger } from "@/lib/motion";

export default function ContactForm() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="border-t border-line bg-sand/60 py-20 lg:py-28"
    >
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
        >
          <motion.div variants={fadeUp} className="mb-4 flex items-center gap-4">
            <span className="h-px w-12 bg-gold" />
            <span className="font-mono text-xs font-semibold uppercase tracking-[0.28em] text-forest">
              Contact
            </span>
          </motion.div>
          <motion.div variants={fadeUp} className="mt-10 space-y-5">
            <div className="flex items-center gap-4 text-sm text-zinc-700">
              <span className="flex h-10 w-10 items-center justify-center border border-line bg-white">
                <Mail className="h-4 w-4 text-forest" />
              </span>
              <span data-testid="contact-email-link">info@e-connect.uk</span>
            </div>
            <div className="flex items-center gap-4 text-sm text-zinc-700">
              <span className="flex h-10 w-10 items-center justify-center border border-line bg-white">
                <MapPin className="h-4 w-4 text-forest" />
              </span>
              London, United Kingdom
            </div>
          </motion.div>
        </motion.div>


      </div>
    </section>
  );
}
